import {
  calcLi,
  calcRdiDgruppe,
  calcRemainingBemessungslast,
  calcRsdi,
  calcSumLi,
  calcSumRsd,
  calcSumRsdi,
  calcTi,
  calcTiBeta,
} from "./berechneSchichten.service";

export function berechneSchichtenGruppe(props) {
  const {
    schichtenInput,
    bohrkronendurchmesser,
    teilsicherheitsbeiwert,
    modellfaktor,
    pfahlneigungZurVertikalen,
    bemessungslastGruppeGesamt,
    umfangErsatzpfahl,
  } = props;

  let remainingBemessungslast = Number(bemessungslastGruppeGesamt);
  let schichten = [];
  let sumLi = 0;
  let sumRsdi = 0;
  let sumRsd = 0;

  for (let index = 0; index < schichtenInput.length; index++) {
    const element = schichtenInput[index];

    // Make some Numbers :)
    let bisNumber = Number(element.bis);
    let vonNumber = Number(element.von);
    let qskiNumber = Number(element.qski);
    let aNumber = Number(element.a);

    // RdiDgruppe
    let RdiDgruppe = calcRdiDgruppe(
      bemessungslastGruppeGesamt,
      teilsicherheitsbeiwert,
      umfangErsatzpfahl,
      qskiNumber
    );

    // ti
    let Ti = calcTi(vonNumber, bisNumber);

    // Li
    let Li = calcLi(RdiDgruppe, Ti, pfahlneigungZurVertikalen, remainingBemessungslast);

    // Rsdi
    let Rsdi = calcRsdi(RdiDgruppe, Li);

    // TiBeta
    let TiBeta = calcTiBeta(Ti, pfahlneigungZurVertikalen);

    // Fd,Rest
    remainingBemessungslast = calcRemainingBemessungslast(remainingBemessungslast, Li, RdiDgruppe);

    // rsd
    sumRsd = calcSumRsd(
      sumRsd,
      bohrkronendurchmesser,
      aNumber,
      Li,
      qskiNumber,
      teilsicherheitsbeiwert,
      modellfaktor
    );

    // update Table Result Sums
    sumLi = calcSumLi(sumLi, Li);
    sumRsdi = calcSumRsdi(sumRsdi, Rsdi);

    let resultSchicht = {
      index: index,
      rdi: RdiDgruppe,
      liZeta: Li,
      rsdi: Rsdi,
      fdRest: remainingBemessungslast,
      ti: TiBeta,
    };

    schichten.push(resultSchicht);
  }

  return {
    schichten,
    resultSumLi: sumLi,
    resultSumRsdi: sumRsdi,
    bemessungspfahlwiderstand: sumRsd,
  };
}
